import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FarmService } from 'src/app/services/farm-service.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: "smart-create-schedual",
  templateUrl: "./create-schedual.component.html",
  styleUrls: [
    "./create-schedual.component.css",
    "../../platform-color/platform-color.css",
  ],
})
export class CreateSchedualComponent implements OnInit {
  farmId: string;
  plotId: string;
  sensorId: string;
  thingId: string;

  formSchedual: FormGroup;
  Schedual: boolean = false;
  Condition: boolean = false;
  type = [];
  lengthForm: number;
  thingList = [];
  sensor: any;
  things: any;
  sensorByThing = [];
  sensorByThingOther = [];
  TimeSt = [];
  Hours = [];
  Minutes = [];

  txtSw: string;
  txtSwCondition: string;
  txtSwConditionOther: string;

  isSubmitted: boolean = true;
  alertErrorSchAndCon: boolean = false;
  constructor(
    private farm: FormBuilder,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private farmService: FarmService
  ) {
    this.farmId = this.route.snapshot.queryParams["farmId"];
    this.plotId = this.route.snapshot.queryParams["plotId"];
    this.sensorId = this.route.snapshot.queryParams["sensorId"];
    this.thingId = this.route.snapshot.queryParams["thingId"];
    this.setTimeList();
    this.createForm();
  }

  setTimeList() {
    for (let index = 0; index < 24; index++) {
      let dataHour = index.toString();
      if (dataHour.length == 1) {
        dataHour = "0" + dataHour;
      }

      this.Hours.push(dataHour);
    }

    for (let index = 0; index < 60; index++) {
      let dataMinute = index.toString();
      if (dataMinute.length == 1) {
        dataMinute = "0" + dataMinute;
      }

      this.Minutes.push(dataMinute);
    }
  }

  createForm() {
    this.formSchedual = this.farm.group({
      schedual_type: new FormControl("", [Validators.required]),
      schedual_time_start: this.farm.array([]),
      schedual_work: new FormControl("", [Validators.required]),
      schedual_time: new FormControl("", [Validators.required]),
      schedual_time_unit: new FormControl("", [Validators.required]),
      sensor_id: "",
      thing_id: "",
      condition: "",
      target1: "",
      target2: "",
      switch_main: "",
      time: "",
      time_unit: "",
      other_sensor_id: "",
      other_thing_id: "",
      other_condition: "",
      other_target1: "",
      other_target2: "",
      other_switch_main: "",
      other_time: "",
      other_time_unit: "",
      operation: "",
    });
    this.txtSw = "ปิด";
    this.txtSwCondition = "ปิด";
    this.txtSwConditionOther = "ปิด";

    this.lengthForm = this.formSchedual.value.schedual_time_start.length;
    const form = (<FormArray>(
      this.formSchedual.get("schedual_time_start")
    )) as FormArray;
    form.push(
      this.farm.group({
        schedual_hours: "",
        schedual_minutes: "",
      })
    );
  }

  ngOnInit() {
    window.scroll(0, 0);

    this.getThings(this.thingId, this.sensorId);
  }

  getThings(id, sensor) {
    this.spinner.show();
    this.farmService
      .getThingById(this.farmId, this.plotId)
      .subscribe(async (success) => {
        if (success.code == 200) {
          this.thingList = success.data;
          var foundThing = this.thingList.find(function (element) {
            return element.thing_id == id;
          });

          var foundSensor = foundThing.control.find(function (element) {
            return element.sensor_id == sensor;
          });
          this.sensor = foundSensor;
          this.things = foundThing;
        }
      });
  }

  selectThings(type, id) {
    let split = id.split(",");
    var foundThing = this.thingList.find(function (element) {
      return element.thing_id == split[0];
    });

    if (foundThing) {
      if (type == "main") {
        this.sensorByThing = foundThing.sensor;
      } else {
        this.sensorByThingOther = foundThing.sensor;
      }
    }
  }

  addForm() {
    const form = (<FormArray>(
      this.formSchedual.get("schedual_time_start")
    )) as FormArray;
    form.push(
      this.farm.group({
        schedual_hours: "",
        schedual_minutes: "",
      })
    );
  }

  removeForm(index: number) {
    const form = (<FormArray>(
      this.formSchedual.get("schedual_time_start")
    )) as FormArray;
    form.removeAt(index);
  }

  onSelectCreate(type: string, event: string) {
    let checkedschedual = $("#schedual_chx").prop("checked");
    let checkedcondition = $("#condition").prop("checked");
    let customSwitchSCH = $("#customSwitchSCH").prop("checked");
    let customSwitch2 = $("#customSwitch2").prop("checked");
    let other_switch_main = $("#other_switch_main").prop("checked");

    if (checkedschedual == true) {
      this.Schedual = true;
    } else {
      this.Schedual = false;
    }

    if (checkedcondition == true) {
      this.Condition = true;
    } else {
      this.Condition = false;
    }

    if (customSwitchSCH == true) {
      this.txtSw = "เปิด";
    } else {
      this.txtSw = "ปิด";
    }
    if (other_switch_main == true) {
      this.txtSwConditionOther = "เปิด";
    } else {
      this.txtSwConditionOther = "ปิด";
    }

    if (customSwitch2 == true) {
      this.txtSwCondition = "เปิด";
    } else {
      this.txtSwCondition = "ปิด";
    }
  }

  chkScheduleAndCondition() {
    let checkedschedual = $("#schedual_chx").prop("checked");
    let checkedcondition = $("#condition").prop("checked");
    let xx = $("#customSwitchSCH").val();

    if (checkedschedual == true) {
      $("#Schedule").removeClass("dis-none");
      $("#removeForm0").addClass("dis-none");
    } else if (checkedschedual == false) {
      $("#Schedule").addClass("dis-none");
      $("#customSwitchSCH").prop("checked", false);
      $("#schedule_DMY").val("");
      this.type = [];
      $("#schedual_time_start").val("");
      $("#customSwitchSCH").val("");
      // this.txtSw = "ปิด";
      $("#schedule_time_input").val("");
      $("#schedule_time").val("");
      this.formSchedual.value.schedual_type = "";
      // this.formSchedual.value.time_start = "";
      this.formSchedual.get("schedual_time_start")["controls"] = [];
      const checkTimeStart = (<FormArray>(
        this.formSchedual.get("schedual_time_start")
      )) as FormArray;
      checkTimeStart.push(
        this.farm.group({
          schedual_hours: "",
          schedual_minutes: "",
        })
      );
      this.formSchedual.value.schedual_time_start = "";
      this.formSchedual.value.schedual_work = "";
      this.formSchedual.value.schedual_time = "";
      this.formSchedual.value.schedual_time_unit = "";
    }

    if (checkedcondition == true) {
      $("#condition_main").removeClass("dis-none");
    } else if (checkedcondition == false) {
      $("#condition_main").addClass("dis-none");

      $("#thing_id").val("");
      $("#condition_sensor").val("");
      $("#condition_con").val("");
      $("#condition_val").val("");
      $("#condition_val_start").val("");
      $("#condition_val_end").val("");
      $("#customSwitch2").val("");
      $("#condition_time_input").val("");
      $("#condition_time").val("");
      $("#customSwitch2").prop("checked", false);
      this.formSchedual.value.thing_id = "";
      this.formSchedual.value.sensor_id = "";
      this.formSchedual.value.condition = "";
      this.formSchedual.value.target1 = "";
      this.formSchedual.value.target2 = "";
      this.formSchedual.value.switch_main = "";
      this.formSchedual.value.time = "";
      this.formSchedual.value.time_unit = "";

      $("#pnCondition").addClass("dis-none");

      $("#condition_and_or").val("");
      $("#other_thing_id").val("");
      $("#other_condition_sensor").val("");
      $("#other_condition").val("");
      $("#condition_and_or_val").val("");
      $("#condition_and_or_val_start").val("");
      $("#condition_and_or_val_end").val("");
      $("#other_switch_main").val("");
      $("#condition_and_or_time_input").val("");
      $("#condition_and_or_time").val("");
      $("#other_switch_main").prop("checked", false);
      this.formSchedual.value.other_thing_id = "";
      this.formSchedual.value.other_sensor_id = "";
      this.formSchedual.value.other_condition = "";
      this.formSchedual.value.other_target1 = "";
      this.formSchedual.value.other_target2 = "";
      this.formSchedual.value.other_switch_main = "";
      this.formSchedual.value.other_time = "";
      this.formSchedual.value.other_time_unit = "";
    }
  }

  selectType(value) {
    this.type = [];
    let week = [];
    let weekval = [];
    let month = [];
    let monthval = [];

    week[1] = "วันอาทิตย์";
    week[2] = "วันจันทร์";
    week[3] = "วันอังคาร";
    week[4] = "วันพุธ";
    week[5] = "วันพฤหัสบดี";
    week[6] = "วันศุกร์";
    week[7] = "วันเสาร์";

    weekval[1] = "SUN";
    weekval[2] = "MON";
    weekval[3] = "TUE";
    weekval[4] = "WED";
    weekval[5] = "THU";
    weekval[6] = "FRI";
    weekval[7] = "SAT";

    month[1] = "มกราคม";
    month[2] = "กุมภาพันธ์";
    month[3] = "มีนาคม";
    month[4] = "เมษายน";
    month[5] = "พฤษภาคม";
    month[6] = "มิถุนายน";
    month[7] = "กรกฎาคม";
    month[8] = "สิงหาคม";
    month[9] = "กันยายน";
    month[10] = "ตุลาคม";
    month[11] = "พฤศจิกายน";
    month[12] = "ธันวาคม";

    monthval[1] = "JAN";
    monthval[2] = "FEB";
    monthval[3] = "MAR";
    monthval[4] = "ARP";
    monthval[5] = "MAY";
    monthval[6] = "JUN";
    monthval[7] = "JUL";
    monthval[8] = "AUG";
    monthval[9] = "SEP";
    monthval[10] = "OCT";
    monthval[11] = "NOV";
    monthval[12] = "DEC";

    if (value != "Daily") {
      if (value == "7") {
        for (let index = 1; index <= value; index++) {
          const element = index;
          this.type.push({
            data: week[element],
            val: weekval[element],
          });
        }
      } else {
        for (let index = 1; index <= value; index++) {
          const element = index;
          this.type.push({
            data: month[element],
            val: monthval[element],
          });
        }
      }
    }
  }

  addCondition() {
    $("#pnCondition").removeClass("dis-none");
  }

  removeCondition() {
    $("#pnCondition").addClass("dis-none");
    $("#condition_and_or").val("");
    $("#other_thing_id").val("");
    $("#other_condition_sensor").val("");
    $("#other_condition").val("");
    $("#condition_and_or_val").val("");
    $("#condition_and_or_val_start").val("");
    $("#condition_and_or_val_end").val("");
    $("#condition_and_or_time_input").val("");
    $("#condition_and_or_time").val("");
    $("#other_switch_main").prop("checked", false);
    this.formSchedual.value.operation = "";
    this.formSchedual.value.other_thing_id = "";
    this.formSchedual.value.other_sensor_id = "";
    this.formSchedual.value.other_condition = "";
    this.formSchedual.value.other_target1 = "";
    this.formSchedual.value.other_target2 = "";
    this.formSchedual.value.other_switch_main = "";
    this.formSchedual.value.other_time = "";
    this.formSchedual.value.other_time_unit = "";
  }

  // issue#80
  isSubmittedSchedule() {
    this.isSubmitted = true;
    let sch_dmy = $("#schedule_DMY").val();
    let type = $("#type").val();
    let hours = $("#hours").val();
    let minutes = $("#minutes").val();
    let schedule_time_input = $("#schedule_time_input").val();
    let schedule_time = $("#schedule_time").val();

    let checkedschedual = $("#schedual_chx").prop("checked");
    let checkedcondition = $("#condition").prop("checked");

    let thing_id = $("#thing_id").val();
    let condition_sensor = $("#condition_sensor").val();
    let condition_con = $("#condition_con").val();
    let condition_val = $("#condition_val").val();
    let condition_val_start = $("#condition_val_start").val();
    let condition_val_end = $("#condition_val_end").val();
    let condition_time_input = $("#condition_time_input").val();
    let condition_time = $("#condition_time").val();

    let condition_and_or = $("#condition_and_or").val();

    let other_thing_id = $("#other_thing_id").val();
    let other_condition_sensor = $("#other_condition_sensor").val();
    let other_condition = $("#other_condition").val();
    let condition_and_or_val = $("#condition_and_or_val").val();
    let condition_and_or_val_start = $("#condition_and_or_val_start").val();
    let condition_and_or_val_end = $("#condition_and_or_val_end").val();
    let condition_and_or_time_input = $("#condition_and_or_time_input").val();
    let condition_and_or_time = $("#condition_and_or_time").val();

    if (checkedschedual == false && checkedcondition == false) {
      this.isSubmitted = false;
    }

    if (checkedschedual == true) {
      if (
        sch_dmy == "" ||
        sch_dmy == null ||
        hours == "" ||
        hours == null ||
        minutes == "" ||
        minutes == null ||
        schedule_time_input == "" ||
        schedule_time_input == null ||
        schedule_time == "" ||
        schedule_time == null
      ) {
        this.isSubmitted = false;
      } else if (sch_dmy && sch_dmy !== "Daily") {
        let count = 0;
        for (let i = 0; i < this.type.length; i++) {
          let type = $("#type" + i).prop("checked");
          if (type == false) {
            count++;
          }
        }
        if (count == this.type.length) {
          this.isSubmitted = false;
        }
      } else {
        this.isSubmitted = true;
      }
    }

    if (checkedcondition == true) {
      if (
        thing_id == "" ||
        condition_sensor == "" ||
        condition_con == "" ||
        condition_time_input == "" ||
        condition_time == ""
      ) {
        this.isSubmitted = false;
      } else if (condition_con == "5") {
        if (condition_val_start == "" || condition_val_end == "") {
          this.isSubmitted = false;
        }
      } else {
        if (condition_val == "") {
          this.isSubmitted = false;
        }
      }
      if (
        condition_and_or != "" &&
        condition_and_or != null &&
        condition_and_or != undefined
      ) {
        if (
          other_thing_id == "" ||
          other_condition_sensor == "" ||
          other_condition == "" ||
          condition_and_or_time_input == "" ||
          condition_and_or_time == ""
        ) {
          this.isSubmitted = false;
        } else if (other_condition == "5") {
          if (
            condition_and_or_val_start == "" ||
            condition_and_or_val_end == ""
          ) {
            this.isSubmitted = false;
          }
        } else {
          if (condition_and_or_val == "") {
            this.isSubmitted = false;
          }
        }
      }
    }
  }

  create() {
    this.isSubmittedSchedule();
    if (this.isSubmitted == true) {
      this.alertErrorSchAndCon = false;
      let typeArr = [];
      let schedules = [];
      let operations = [];
      let mergCondition = [];

      operations["1"] = ">";
      operations["2"] = "<";
      operations["3"] = "=";
      operations["4"] = "<>";
      operations["5"] = "BETWEEN";

      $("input:checkbox[name=type]:checked").each(function () {
        typeArr.push($(this).val());
      });

      let splitThing = this.formSchedual.value.thing_id.split(",");
      let splitSensor = this.formSchedual.value.sensor_id.split(",");
    
      let Condition = {
        thing_id: splitThing[0],
        thing_name: splitThing[1],
        sensor_id: splitSensor[0],
        sensor_name: splitSensor[1],
        operation: operations[this.formSchedual.value.condition],
        Value1: this.formSchedual.value.target1,
        Value2:
          this.formSchedual.value.target2 == ""
            ? null
            : this.formSchedual.value.target2,
        sch_time: this.formSchedual.value.time,
        sch_unit_time: this.formSchedual.value.time_unit,
        sensor_action:
          this.formSchedual.value.switch_main == true ? "ON" : "OFF",
      };

      let splitThing_other = this.formSchedual.value.other_thing_id.split(",");
      let splitSensor_other =
        this.formSchedual.value.other_sensor_id.split(",");

      if (
        this.formSchedual.value.operation != null &&
        this.formSchedual.value.operation != ""
      ) {
        let ConditionTwo = {
          thing_id: splitThing_other[0],
          thing_name: splitThing_other[1],
          sensor_id: splitSensor_other[0],
          sensor_name: splitSensor_other[1],
          operation: operations[this.formSchedual.value.other_condition],
          Value1: this.formSchedual.value.other_target1,
          Value2:
            this.formSchedual.value.other_target2 == ""
              ? null
              : this.formSchedual.value.other_target2,
          sch_time: this.formSchedual.value.other_time,
          sch_unit_time: this.formSchedual.value.other_time_unit,
          sensor_action:
            this.formSchedual.value.other_switch_main == true ? "ON" : "OFF",
        };
        mergCondition.push(Condition, ConditionTwo);
      } else {
        mergCondition.push(Condition);
      }

      let jsonData = JSON.stringify(mergCondition);

      let checkedschedual = $("#schedual_chx").prop("checked");
      let checkedcondition = $("#condition").prop("checked");

      if (checkedschedual == true && checkedcondition == false) {
        var sch_flag = "SCH";
      } else if (checkedschedual == false && checkedcondition == true) {
        var sch_flag = "CON";
      } else if (checkedschedual == true && checkedcondition == true) {
        var sch_flag = "ALL";
      }

      if (this.formSchedual.value.schedual_type == "7") {
        this.formSchedual.value.schedual_type = "Weekly";
      } else if (this.formSchedual.value.schedual_type == "12") {
        this.formSchedual.value.schedual_type = "Monthly";
      } else {
        this.formSchedual.value.schedual_type =
          this.formSchedual.value.schedual_type;
      }

      this.formSchedual.value.schedual_time_start.forEach((element: any) => {
        const typeArrayJoined = typeArr.join(",");
        const isTypeArrayEmpty = typeArrayJoined === "";
        const timeStart =
          element.time_start == ""
            ? null
            : this.convertTime(
                element.schedual_hours,
                element.schedual_minutes
              );

        const scheduleData = {
          sch_name: "",
          sch_type: this.formSchedual.value.schedual_type || null,
          sch_date: isTypeArrayEmpty ? null : typeArrayJoined,
          sch_time: this.formSchedual.value.schedual_time || null,
          sch_unit_time: this.formSchedual.value.schedual_time_unit || null,
          sch_start_time: timeStart,
          sch_stop_time: timeStart,
          thing_id: this.thingId,
          sensor_id: this.sensorId,
          condition: this.formSchedual.value.sensor_id == "" ? null : jsonData,
          operation: this.formSchedual.value.operation || null,
          sensor_action: this.formSchedual.value.schedual_work ? "ON" : "OFF",
          sch_flag: sch_flag,
          sch_status: "ATV",
          plot_id: this.plotId,
        };

        if (isTypeArrayEmpty) {
          scheduleData.sch_date = "";
        }

        schedules.push(scheduleData);
      });

      this.createSchedule(schedules);
    } else {
      this.alertErrorSchAndCon = true;
    }
  }

  createSchedule(schedules) {
    this.spinner.show();
    setTimeout(async () => {
      this.farmService
        .getInsertScheduleAndCodition(schedules)
        .then(async (success) => {
          if (success.code == 200) {
            $("#setSchedual").modal("hide");
            Swal.fire({
              icon: "success",
              title: "ดำเนินการเสร็จสิ้น",
              showConfirmButton: false,
              timer: 1500,
            });
            this.spinner.show();
            setTimeout(async () => {
              window.location.reload();
            }, 1800);
          } else {
            $("#setSchedual").modal("hide");
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาดในการสร้าง กรุณาลองใหม่อีกครั้ง",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      this.spinner.hide();
    }, 100);
  }

  convertTime(hour, minutes) {
    var m = moment(new Date(0, 0, 0, hour, minutes, 0));
    return moment(m, "YYYY-MM-DD HH:mm:ss", "Asia/Bangkok").format("HH.mm.ss");
  }

  selectOperation(type, event) {
    if (type == "CH") {
      this.formSchedual.controls["target1"].setValue("");
      this.formSchedual.controls["target2"].setValue("");
      if (event == "5") {
        $("#UnBtwCH").addClass("dis-none");
        $("#BtwCh").removeClass("dis-none");
      } else {
        $("#UnBtwCH").removeClass("dis-none");
        $("#BtwCh").addClass("dis-none");
      }
    } else {
      this.formSchedual.controls["other_target1"].setValue("");
      this.formSchedual.controls["other_target2"].setValue("");
      if (event == "5") {
        $("#UnBtwCo").addClass("dis-none");
        $("#BtwCo").removeClass("dis-none");
      } else {
        $("#UnBtwCo").removeClass("dis-none");
        $("#BtwCo").addClass("dis-none");
      }
    }
  }

  cancelSchduleAndCondition() {
    setTimeout(async () => {
      this.txtSw = "ปิด";
      this.txtSwCondition = "ปิด";
      this.txtSwConditionOther = "ปิด";
      this.alertErrorSchAndCon = false;
      this.type = [];

      $("#schedual_chx").prop("checked", false);
      $("#Schedule").addClass("dis-none");
      $("#customSwitchSCH").prop("checked", false);
      $("#schedule_DMY").val("");
      $("#schedual_time_start").val("");
      $("#customSwitchSCH").val("");
      $("#schedule_time_input").val("");
      $("#schedule_time").val("");
      this.formSchedual.value.schedual_type = "";
      // this.formSchedual.value.time_start = "";
      this.formSchedual.get("schedual_time_start")["controls"] = [];
      const checkTimeStart = (<FormArray>(
        this.formSchedual.get("schedual_time_start")
      )) as FormArray;
      checkTimeStart.push(
        this.farm.group({
          schedual_hours: "",
          schedual_minutes: "",
        })
      );
      this.formSchedual.value.schedual_time_start = "";
      this.formSchedual.value.schedual_work = "";
      this.formSchedual.value.schedual_time = "";
      this.formSchedual.value.schedual_time_unit = "";

      //<.....condition......>
      $("#condition").prop("checked", false);
      $("#condition_main").addClass("dis-none");
      $("#thing_id").val("");
      $("#condition_sensor").val("");
      $("#condition_con").val("");
      $("#condition_val").val("");
      $("#condition_val_start").val("");
      $("#condition_val_end").val("");
      $("#customSwitch2").val("");
      $("#condition_time_input").val("");
      $("#condition_time").val("");
      $("#customSwitch2").prop("checked", false);
      this.formSchedual.value.thing_id = "";
      this.formSchedual.value.sensor_id = "";
      this.formSchedual.value.condition = "";
      this.formSchedual.value.target1 = "";
      this.formSchedual.value.target2 = "";
      this.formSchedual.value.switch_main = "";
      this.formSchedual.value.time = "";
      this.formSchedual.value.time_unit = "";
      $("#pnCondition").addClass("dis-none");
      $("#condition_and_or").val("");
      $("#other_thing_id").val("");
      $("#other_condition_sensor").val("");
      $("#other_condition").val("");
      $("#condition_and_or_val").val("");
      $("#condition_and_or_val_start").val("");
      $("#condition_and_or_val_end").val("");
      $("#other_switch_main").val("");
      $("#condition_and_or_time_input").val("");
      $("#condition_and_or_time").val("");
      $("#other_switch_main").prop("checked", false);
      this.formSchedual.value.other_thing_id = "";
      this.formSchedual.value.other_sensor_id = "";
      this.formSchedual.value.other_condition = "";
      this.formSchedual.value.other_target1 = "";
      this.formSchedual.value.other_target2 = "";
      this.formSchedual.value.other_switch_main = "";
      this.formSchedual.value.other_time = "";
      this.formSchedual.value.other_time_unit = "";
      this.sensorByThing = [];
      this.sensorByThingOther = [];
    }, 10);
    this.alertErrorSchAndCon = false;
    this.removeForm(-1);
  }
}
